var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIconBuilding(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 52,
    height: 52,
    viewBox: "0 0 52 52",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M28.167 23.8333H42.3003C43.4204 23.8333 43.9805 23.8333 44.4083 24.0513C44.7846 24.2431 45.0906 24.549 45.2823 24.9254C45.5003 25.3532 45.5003 25.9132 45.5003 27.0333V45.5",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M28.1663 45.5V13.4333C28.1663 11.0064 28.1663 9.79299 27.694 8.86604C27.2786 8.05067 26.6157 7.38776 25.8003 6.97231C24.8734 6.5 23.6599 6.5 21.233 6.5H13.433C11.0061 6.5 9.79267 6.5 8.86572 6.97231C8.05035 7.38776 7.38743 8.05067 6.97198 8.86604C6.49967 9.79299 6.49967 11.0064 6.49967 13.4333V45.5M47.6663 45.5H4.33301M14.083 15.1667H20.583M14.083 23.8333H20.583M14.083 32.5H20.583",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconBuilding);
export default __webpack_public_path__ + "static/media/IconBuilding.c270876b03ccb4dc219791687273bccb.svg";
export { ForwardRef as ReactComponent };